export default __webpack_public_path__ + "static/media/PowerHarrow.9af9187a.jpg";